const USER_STORAGE_KEY = 'user';

export const isCrossTabLogoutEvent = (event: StorageEvent): boolean => {
    const isLocalStorageEvent = event.storageArea === window.localStorage;
    const wasUserRemoved = event.key === USER_STORAGE_KEY && event.newValue === null;
    const wasStorageCleared = event.key === null;

    return isLocalStorageEvent && (wasUserRemoved || wasStorageCleared);
};

export const subscribeToCrossTabLogout = (onLogout: () => void): (() => void) => {
    const handleStorageChange = (event: StorageEvent) => {
        if (isCrossTabLogoutEvent(event)) {
            onLogout();
        }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => window.removeEventListener('storage', handleStorageChange);
};
